import { styled } from 'styled-components'
import { Block, Text } from 'suomifi-ui-components'
import media from 'common-ui-components/src/vtj/theme/media'
import { responsiveMaxWidth } from 'common-ui-components/src/vtj/theme/helpers'
import { Link } from 'react-router-dom'

export const TabNavigationContainerLandingPage = styled(Block)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  margin-bottom: ${(props) => props.theme.spacing.m};

  ${media.mobileAndTablet} {
    flex-direction: column;
    margin-bottom: ${(props) => props.theme.spacing.s};
  }

  ${media.mobileContent} {
    padding: 0;
  }
`

export const TabNavigationContainerWizard = styled(Block)`
  display: block;
  background-color: ${(props) => props.theme.colors.whiteBase};
  border-bottom: 1px solid ${(props) => props.theme.colors.depthLight1};
  width: 100%;
`

export const TabListLandingPage = styled(Block)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: ${(props) => props.theme.spacing.xxl}
    ${(props) => props.theme.spacing.s} 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.depthLight1};
  ${media.mobileAndTablet} {
    flex-direction: column;
    margin-top: ${(props) => props.theme.spacing.xs};
    margin-bottom: ${(props) => props.theme.spacing.s};
    border-bottom: 0;
    padding: 0;
  }

  width: 100%;
`

export const TabListWizard = styled(Block)`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  ${responsiveMaxWidth()};

  ${media.mobileAndTablet} {
    margin-top: ${(props) => props.theme.spacing.xs};
    flex-direction: column;
  }
`

export const TabLandingPage = styled(Link)<{
  $isActive: boolean
}>`
  padding: ${(props) => props.theme.spacing.xxs} 0;
  & + & {
    margin-left: ${(props) => props.theme.spacing.xxl};
  }
  color: black;
  &:visited {
    color: black;
  }
  border-bottom: ${({ $isActive, theme }) =>
    $isActive
      ? `solid ${theme.spacing.insetXs} ${theme.colors.highlightBase}`
      : 'none'};
  text-decoration: none !important;

  ${media.mobileAndTablet} {
    width: 100%;
    padding: ${(props) => props.theme.spacing.xs};
    border-bottom: none;
    border-left: ${({ $isActive, theme }) =>
      `solid ${theme.spacing.insetXs} ${
        $isActive ? theme.colors.highlightBase : 'transparent'
      }`};
    background-color: ${({ $isActive, theme }) =>
      $isActive ? `${theme.colors.highlightLight3}` : 'none'};
    & + & {
      margin-left: 0;
    }
  }
  span {
    font-weight: ${({ $isActive }) => ($isActive ? 'bold' : 'initial')};
  }
`

export const TabWizard = styled(TabLandingPage)<{
  $isActive: boolean
}>`
  min-height: 50px;
  margin-right: ${(props) => props.theme.spacing.m};
  padding: 0 ${(props) => props.theme.spacing.xxs};
  text-transform: none;
  display: flex;
  align-items: center;
`

export const CertificateCount = styled(Text)`
  display: inline-block;
  margin-left: ${(props) => props.theme.spacing.xxs};
  text-align: center;
  background-color: ${(props) => props.theme.colors.highlightBase};
  color: white;
  padding: 0 ${(props) => props.theme.spacing.xxs};
  border-radius: ${(props) => props.theme.spacing.s};
  min-width: 27px;
`
